<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-hxBiz-jdOrder',
  components: { PageTable },
}
</script>
